const ContactUs = () => {
  return (
    <section id="fale-conosco" className="content-section">
      <div className="card mb-3">
        {/* Card title */}
        <div className="card-body text-center">
          <h5 className="card-title">Fale Conosco</h5>
        </div>

        <div className="card-body mx-auto">
          <div className="card">
            <div className="card-body">
              <a href="./res/pdf/terms_of_use.pdf" target="_blank" rel="noopener noreferrer">
                <p className="text-decoration-underline mb-0">Termos de Uso</p>
              </a>
              <a href="./res/pdf/privacy_policy.pdf" target="_blank" rel="noopener noreferrer">
                <p className="text-decoration-underline">Política de privacidade</p>
              </a>

              <p className="mb-0">
                <strong>Suporte a clientes: </strong>(48) 2106 0006
              </p>
              <p className="mb-0">
                <strong>Fórum: </strong>
                <a href="https://forum.intelbras.com.br" target="_blank" rel="noopener noreferrer" className="text-decoration-underline">
                  forum.intelbras.com.br
                </a>
              </p>
              <p className="mb-0">
                <strong>Suporte via chat e e-mail: </strong>
                <a href="https://intelbras.com.br/suporte-tecnico" target="_blank" rel="noopener noreferrer" className="text-decoration-underline">
                  intelbras.com.br/suporte-tecnico
                </a>
              </p>
              <p className="mb-0">
                <strong>SAC: </strong>0800 704 2767
              </p>
              <p className="mb-0">
                <strong>Onde comprar? Quem instala?: </strong>0800 724 5115
              </p>
              <p className="mb-0">
                <strong>Produzido por:</strong> Intelbras S/A – Indústria de Telecomunicação Eletrônica Brasileira
              </p>
              <p className="mb-0">
                Rodovia SC 281, km 4,5 – Sertão do Maruim – São José/SC – 88122-001
              </p>
              <p className="mb-0">
                CNPJ 82.901.000/0014-41 – <a href="https://intelbras.com.br" target="_blank" rel="noopener noreferrer" className="text-decoration-underline">
                  intelbras.com.br
                </a>
              </p>
              <p className="mb-0">
                Indústria Brasileira
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

  );
};

export default ContactUs;
